import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;



const updateXeroKey = (credentials = {}) => {
  const action = "afterlogin/xero/connect";
  const data = {};
  for (const [input, field] of Object.entries({
    client_id: "xero_client_id",
    client_secret: "xero_secret_id",
  })) {
    if (credentials[input] !== undefined) data[field] = credentials[input];
  }
  return axios.post(API_URL + action, data, {
    headers: authHeader(),
  });
};

const handleCallback = (code, state) => {
  const action = "afterlogin/xero/callback";
  return axios.post(API_URL + action, { code, state }, {
    headers: authHeader(),
  });
};

const disconnect = () => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();

  const action = "afterlogin/xero/disconnect";
  formData.append("auth_key", auth_key);
  formData.append("action", action);

  return axios.post(API_URL + action, formData, {
    headers: authHeader({ contentType: "multipart/form-data" }),
  });
};

const buildLogFormData = (endpoint) => {
  const auth = store.getState().auth;
  const formData = new FormData();
  formData.append("auth_key", auth.user.auth_key);
  formData.append("salon_id", auth.user.salon_id);
  formData.append("action", endpoint);
  return formData;
};

const postLogAction = (endpoint, build = () => {}) => {
  const formData = buildLogFormData(endpoint);
  build(formData);
  return axios.post(API_URL + endpoint, formData, {
    headers: authHeader({ contentType: "multipart/form-data" }),
  });
};

const encodeList = (values) => JSON.stringify(Array.isArray(values) ? values : []);



const fetchConnection = () =>
  postLogAction("afterlogin/xero/logs/connection");

const fetchFilterOptions = () =>
  postLogAction("afterlogin/xero/logs/filter-options");

const fetchAnalytics = (values = {}) =>
  postLogAction("afterlogin/xero/logs/analytics", (formData) => {
    formData.append("period", values.period ?? "all");
    formData.append("status", values.status || "");
    formData.append("invoice_numbers", encodeList(values.invoice_numbers));
    formData.append("paidby", encodeList(values.paidby));
  });

const fetchLogs = (values = {}) =>
  postLogAction("afterlogin/xero/logs/list", (formData) => {
    formData.append("page", values.page ?? 1);
    formData.append("limit", values.limit ?? 20);
    formData.append("status", values.status || "");
    formData.append("invoice_numbers", encodeList(values.invoice_numbers));
    formData.append("paidby", encodeList(values.paidby));
  });

const resyncLog = (logId, idempotencyKey) => {
  const auth = store.getState().auth;
  const key =
    idempotencyKey ||
    `xero-resync-${auth.user.salon_id}-${logId}-${Date.now()}`;
  return postLogAction("afterlogin/xero/logs/resync", (formData) => {
    formData.append("log_id", logId);
    formData.append("idempotency_key", key);
  });
};

const XeroService = {
  updateXeroKey,
  handleCallback,
  disconnect,
  fetchConnection,
  fetchFilterOptions,
  fetchAnalytics,
  fetchLogs,
  resyncLog,
};

export default XeroService;
